import { useCallback, useState } from "react";
import { useApi } from "../apiCall/useApi";
import Joi from "joi";
import { Urls } from "../../../utils/constant";
import { size } from "lodash";
import { useSnackbar } from "notistack";

import {
  hidePageLoader,
  showPageLoader,
} from "../../reducers/Common/PageLoader/PageLoader.reducer";
import { useDispatch } from "react-redux";

import {
  setAppointmentData,
  setNoteList,
} from "../../reducers/Appointment/appointmentform.reducer";

export function useAppointmentForm() {
  const dispatch = useDispatch();
  const { apiPost } = useApi();
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const AppointmentUpdate = useCallback(
    async ({ id, problem, notes }) => {
      if (loading) return;
      setLoading(true);

      try {
        dispatch(showPageLoader());

        const { data } = await apiPost({
          url: Urls.appointmentUpdate(),
          data: {
            id: id,
            problem: problem,
            notes: notes,
            update_by: "",
          },
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });

        if (size(data.id) === 36) {
          enqueueSnackbar("Appointment Updated Successfully.", {
            variant: "success",
          });
          return true; // Ensure true is returned for success
        }

        setLoading(false);
        dispatch(hidePageLoader());
      } catch (err) {
        dispatch(hidePageLoader());
        console.log(err);
        setLoading(false);
        return false; // Ensure false is returned for failure
      }
    },
    [loading]
  );

  const getAppointmentbyId = useCallback(
    async (id) => {
      if (loading) return;
      setLoading(true);
      try {
        dispatch(showPageLoader());
        const { data } = await apiPost({
          url: Urls.getappointmentDatabyId(),
          data: {
            id: id,
          },
        });

        dispatch(setAppointmentData(data));
        setLoading(false);
        dispatch(hidePageLoader());
      } catch (err) {
        dispatch(hidePageLoader());
        console.log(err);
        setLoading(false);
        return false;
      }
    },
    [loading]
  );

  return {
    getAppointmentbyId,
    AppointmentUpdate,
  };
}
